export default __webpack_public_path__ + "static/media/top_review_contents.9ed18ce4.png";